export default {
  title: 'Produtos',
  description: 'Gerencie os produtos que existem no seu website.',
  labels: {
    new: 'Novo Produto',
  },
  form: {
    title: 'Cadastro de Produto'
  },
  groups: {
    filter: 'Filtro',
    generalData: 'Dados gerais',
  },
  fields: {
    content: 'Conteúdo',
    is_draft: 'Rascunho',
    is_published: 'Publicado',
    language: 'Idioma',
    layout: 'Layout',
    max_depth: 'Limite de itens',
    name: 'Nome do produto',
    page_type: 'Tipo de página',
    plan: 'Plano',
    preview:'Preview',
    slug: 'Slug',
    status: 'Status',
    url: 'URL',
    website: 'Website',
  }
};
